import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import * as breakpoints from '../../../data/breakpoints';

const PaymentHistoryTableRow = ({ paidHistoryEntry }) => {
  const {
    plan,
    amount,
    currency,
    paid,
    status,
    receipt_link: receiptLink,
    payment_date: paymentDate,
    invoice_pdf: invoicePdf,
    amount_due: amountDue,
    amount_paid: amountPaid,
    hosted_invoice_url: hostedInvoiceUrl,
  } = paidHistoryEntry;
  
  let { frequency } = paidHistoryEntry;

  let paymentPlan;
  let cost;
  let costDue;
  let costPaid;

  let currSymbol;
  let rowClass;
  let invoiceClassName;
  let paymentItemLink;
  let paymentItemClass;
  let paymentItemText;
  let paymentItem;
  if (status === `void`) {
    invoiceClassName = `text-green`;
    paymentItemLink = hostedInvoiceUrl;
    paymentItemClass = `text-green`;
    paymentItemText = `Void`;
    rowClass = ``;
  } else if (paid === false) {
    invoiceClassName = `text-red`;
    paymentItemLink = hostedInvoiceUrl;
    paymentItemClass = `text-red`;
    paymentItemText = `Action required`;
    rowClass = `text-red`;
  } else {
    invoiceClassName = `text-green`;
    paymentItemLink = receiptLink;
    paymentItemClass = `text-green`;
    paymentItemText = `Paid`;
    rowClass = ``;
  }

  if ((paid === true && receiptLink !== null) || paid === false) {
    paymentItem = (
      <a href={paymentItemLink} target="_blank" className={paymentItemClass}>{paymentItemText}</a>
    );
  } else {
    paymentItem = paymentItemText;
  }

  const invoice = (
    <a href={invoicePdf} className={invoiceClassName}>Download</a>
    );

  const paidYear = paymentDate.split(`-`)[0];
  const paidMonth = paymentDate.split(`-`)[1];
  const date = `${paidMonth} - ${paidYear}`;

  // If entry is full payment
  if (paidHistoryEntry.plan) {
    // Plan logic
    if (plan === `1DAY_ACCESS_USD`) {
      paymentPlan = `Single day`;
    } else {
      paymentPlan = plan.split(`_`)[0];
    }

    // Currency symbol logic
    if (currency === `gbp`) {
      currSymbol = `£`;
    } else {
      currSymbol = `$`;
    }

   // Frequency logic

    if (frequency === `day`) {
      frequency = `Daily`;
    } else {
      frequency = `${frequency}ly`;
    }

    paymentPlan = paymentPlan.charAt(0).toUpperCase() + paymentPlan.slice(1);

    // Amount logic
    if (currency === `gbp` && frequency !== `day`) {
      cost = `${currSymbol}${amount}.00`;
      costDue = `${currSymbol}${amountDue}.00`;
      costPaid = `${currSymbol}${amountPaid}.00`;
    } else if (currency === `usd` && frequency !== `day`) {
      cost = `${currSymbol}${amount}.00`;
      costDue = `${currSymbol}${amountDue}.00`;
      costPaid = `${currSymbol}${amountPaid}.00`;
    } else {
      cost = `${currSymbol}${amount}`;
      costDue = `${currSymbol}${amountDue}`;
      costPaid = `${currSymbol}${amountPaid}`;
    }
  }

  return (
    <tr className={rowClass}>
      <td>{date}</td>
      <td>{paymentPlan}</td>
      <MediaQuery minWidth={breakpoints.SMALL}>
        <td className="capitalize">{frequency}</td>
      </MediaQuery>
      <td>{cost}</td>
      <td>{costDue}</td>
      <td>{costPaid}</td>
      <td>{invoice}</td>
      <td>{paymentItem}</td>
    </tr>
  );
};

PaymentHistoryTableRow.propTypes = {
  paidHistoryEntry: PropTypes.object.isRequired,
};

export default PaymentHistoryTableRow;


// WEBPACK FOOTER //
// ./library/app/components/Account/PaymentHistory/PaymentHistoryTableRow.js